"use client"
import styled from "@emotion/styled"
import { Box } from "@mui/material"
import Image from "next/image"
import Link from "next/link"
import { ArrowLeftIconNew, NewText } from "ui"
import { getUmbracoMediaUrl } from "utils"

const StyledImageWrapper = styled.div<{ $sizeLarge?: boolean }>`
  width: ${(p) => (p.$sizeLarge ? "260px" : "164px")};
  height: ${(p) => (p.$sizeLarge ? "309px" : "195px")};
  position: relative;
  margin-top: ${(p) => (p.$sizeLarge ? "55px" : "37px")};
`

const StyledBadgeWrapper = styled.div`
  position: absolute;
  top: 8px;
  right: 8px;
  display: flex;
  gap: 8px;
`

const StyledBadge = styled.div`
  display: flex;
  padding: 4px 16px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 40px;
  background: #6f6f6f;
  backdrop-filter: blur(2px);
  height: 31px;
  min-width: 71px;
`

const StyledCard = styled(Link) <{ $sizeLarge?: boolean }>`
  display: flex;
  height: ${(p) => (p.$sizeLarge ? "460px" : "326px")};
  min-width: 238px;
  padding: 8px 0 0 0;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  border-radius: 16px;
  background: var(--Light-grey, #f7f7f7);
  box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.16);
  overflow: hidden;
  text-decoration: none;
  position: relative;
  ${(p) => p.theme.breakpoints.up("lg")} {
    min-width: 298px;
  }
`

const StyledTextWrapper = styled.div<{ locale: string }>`
  width: 100%;
  background: white;
  display: flex;
  padding: 8px 8px 16px 8px;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  ${(p) => p.locale === "en" && "svg {transform: rotate(180deg);}"}
`

const ProductCard = ({
  imageURL,
  productTitle,
  productSubtitle,
  badge,
  productURL,
  locale,
  sizeLarge,
  onClick,
}: {
  imageURL: string
  productTitle: string
  productSubtitle: string[]
  badge?: string[] | []
  productURL: string
  locale: string
  sizeLarge?: boolean
  onClick?: () => void
}) => {
  return (
    <StyledCard href={`/${locale}/${productURL}`} $sizeLarge={sizeLarge} onClick={onClick}>
      <StyledBadgeWrapper>
        {badge &&
          badge?.length > 0 &&
          badge.map((b, index) => (
            <StyledBadge key={index}>
              <NewText
                component={"p"}
                desktopFontSize={16}
                desktopFontWeight={400}
                desktopLineHeight={1}
                color="white"
                height={"fit-content"}
                textTransform={"capitalize"}
              >
                {b}
              </NewText>
            </StyledBadge>
          ))}
      </StyledBadgeWrapper>
      <StyledImageWrapper $sizeLarge={sizeLarge}>
        {imageURL && (
          <Image alt={productTitle} src={getUmbracoMediaUrl(imageURL)} fill objectFit="contain" />
        )}
      </StyledImageWrapper>
      <StyledTextWrapper locale={locale}>
        <NewText
          component={"h3"}
          desktopFontSize={20}
          desktopFontWeight={600}
          desktopLineHeight={1}
          color="black"
        >
          {productTitle}
        </NewText>
        <Box display={"flex"} justifyContent={"space-between"} alignItems={"center"} width={"100%"}>
          <NewText
            component={"p"}
            desktopFontSize={16}
            desktopFontWeight={400}
            desktopLineHeight={1}
            color="black"
            textTransform={"capitalize"}
          >
            {productSubtitle?.join(" , ")}
          </NewText>
          <ArrowLeftIconNew />
        </Box>
      </StyledTextWrapper>
    </StyledCard>
  )
}
export default ProductCard
